module.exports = __webpack_public_path__ + "static/media/garage-open.bab3f5cc.svg";